

<!--&lt;!&ndash;<app-mis ></app-mis>&ndash;&gt;-->
<!--<ng-container *ngIf="!isExternal && !isTransport">-->
<!--  <app-mis2></app-mis2>-->
<!--</ng-container>-->

<!--<ng-container *ngIf="isTransport && !isExternal">-->
<!--  <app-mis-transport></app-mis-transport>-->
<!--</ng-container>-->

<!--<ng-container *ngIf="isExternal && !isTransport">-->
<!--  <app-mis-borivali></app-mis-borivali>-->
<!--</ng-container>-->

<!--&lt;!&ndash;<app-financial-report-assessment-table></app-financial-report-assessment-table>&ndash;&gt;-->


<!--&lt;!&ndash;&ndash;&gt;-->
<ng-container [ngSwitch]="true">
  <app-mis-transport *ngSwitchCase="isTransport && !isExternal"></app-mis-transport>
  <app-mis-borivali *ngSwitchCase="isExternal && !isTransport"></app-mis-borivali>
  <app-mis-education *ngSwitchCase="isEducation && !isTransport"></app-mis-education>
  <app-mis-counselling *ngSwitchCase="isCounselling && !isTransport"></app-mis-counselling>
  <app-mis-donation *ngSwitchCase="isDonor"></app-mis-donation>
  <app-mis2 *ngSwitchCase="isOperations && !isTransport"></app-mis2>
  <app-mis2 *ngSwitchDefault></app-mis2>
</ng-container>

